import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Actions } from '../../store/actions/facilityActions';

import { TableRow, TableCell } from '../ui/table';
import { Button } from '../ui/button';
import { Trash2 } from 'lucide-react';

const FacilityRow = ({ facilityDetails, showFacilitiesDeleteModal, facilityTypes, canDelete }) => {
  return (
    <TableRow className='hover:bg-muted/50 text-base'>
      <TableCell className='font-medium text-left'>{facilityDetails?.name}</TableCell>
      <TableCell>{facilityDetails?.isPrimary === true ? 'Yes' : 'No' || 'N/A'}</TableCell>
      <TableCell>{facilityDetails?.postCode}</TableCell>
      <TableCell>{facilityDetails?.externalId}</TableCell>
      <TableCell className='text-center'>
        <Button
          size='base'
          className='h-8 p-2 bg-secondary text-secondary-foreground hover:text-primary-foreground'
          id='Facility-view-edit'
          asChild>
          <Link to={`/facilities/${facilityDetails.id}`}>View / Edit</Link>
        </Button>
      </TableCell>
      <TableCell className='text-center'>
        {canDelete && (
          <button
            onClick={() => showFacilitiesDeleteModal(true, facilityDetails)}
            className='cursor-pointer text-accent hover:text-destructive duration-300'
            id='deleteFacilityBtn'>
            <Trash2 size={18} strokeWidth={1.5} />
          </button>
        )}
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    facilityModal: state.facility?.facilitiesDeleteModal,
    facilityTypes: state?.facility?.types,
    canDelete:
      (state?.organisation?.permissions?.facilities?.[ownProps.facilityDetails.id]?.delete ??
        state?.organisation?.permissions?.facilities?.['*']?.delete) ||
      false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showFacilitiesDeleteModal: (status, item) => dispatch(Actions.showFacilitiesDeleteModal(status, item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FacilityRow);
